import ApiService from '@/data/services/ApiService'
import { ITest } from '@/data/models/Test'
import { AxiosResponse } from 'axios'
import { IServiceResponse } from '@/data/models/ServiceResponse'

export class DiagnosticTestApiService extends ApiService {
  /**
   * Returns paginated list of Tests
   */
  static async getAll(params: object): Promise<IServiceResponse<ITest>> {
    return this.axios.get('diagnostic-tests', {
      params
    })
      .then((response: AxiosResponse<IServiceResponse<ITest>>) => response.data)
  }
}
